module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeCallback
    }
  }, [_c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "还款时间",
      "prop": "AddTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "还款金额",
      "prop": "RePayMoney"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预收单号",
      "prop": "PreCollectCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "还款说明",
      "prop": "Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61e984cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Agent/AgentLend/components/paymentHistoryListDialog/index.vue
// module id = 1502
// module chunks = 1